import React, { useState } from 'react';
import { initialIPageState, IPageState } from './page';
import { AddNewItemPage } from './page-item/AddPageItem';
import { DataService } from 'src/services/data-service';
import { useNavigate } from 'react-router';
import { Button } from '@mui/material';
import _ from 'lodash';
import { validateForm } from './submission';
import { toast } from 'react-toastify';

const AddPage: React.FC = () => {
  const [pageState, setPageState] = useState<IPageState>(initialIPageState);
  const [submitting, setSubmitting] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSubmit = async () => {
    setSubmitting(true);
    setError(null);

    const { errors, touched, isValid } = validateForm(pageState.values);
    const newState = _.cloneDeep(pageState);
    newState.errors = errors;
    setPageState(newState);
    console.log("Global validation result:", isValid, errors);

    if (!isValid) {
      setSubmitting(false);
      toast.error("Please fix the validation errors before creating the page.");
      return;
    }

    const mappedItems = pageState.values.Items.map((widget) => {
      const { type, code, ...rest } = widget as any;
      return { type, code, data: rest };
    });

    const payload = {
      Code: pageState.values.SEO.Code,
      Title: pageState.values.SEO.Title,
      Description: pageState.values.SEO.Description,
      Config: JSON.stringify({
        SEO: pageState.values.SEO,
        Items: mappedItems
      }),
      Active: true
    };

    try {
      const response = await DataService.post('api/page/create', payload);
      if (!response.ok) {
        const errorMessage = await response.text();
        setError(errorMessage);
        throw new Error(errorMessage);
      }
      const result = await response.json();
      setSuccess(true);
      navigate(`/web-builder/pages/edit/${result?.id}`);
    } catch (err) {
      console.error("Error creating page:", err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <AddNewItemPage
        pageState={pageState}
        onPageStateUpdate={(p) => setPageState(p)}
        submitting={submitting}
      />
      {error && <div style={{ color: 'red' }}>{error}</div>}
      {success && <div style={{ color: 'green' }}>Page created successfully!</div>}
      <Button
        variant="contained"
        color="primary"
        sx={{ mt: 3 }}
        onClick={handleSubmit}
        disabled={submitting}
      >
        {submitting ? 'Updating...' : 'Create Page'}
      </Button>
    </div>
  );
};

export default AddPage;
